export default __webpack_public_path__ + "static/media/silverberry.0134ccc5.png";